"use client";
import React, { useEffect, useState } from "react";
import axios from "axios";
import '../styles/AddonsPage.css';

const AddonsPage = () => {
    const [categoriesData, setCategoriesData] = useState([]); 
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAddons = async () => {
            try {
                const response = await axios.post("https://api.blingnbliss.in/api/get-addons-by-category");
                if (response.data.success) {
                    // The API response's 'data' field already contains the grouped categories
                    setCategoriesData(response.data.data); 
                } else {
                    setError("Failed to fetch data.");
                }
            } catch (error) {
                setError("Failed to fetch data.");
            }
        };

        fetchAddons();
    }, []);

 
    // if (error) {
    //     return <div className="page-content">Error: {error}</div>;
    // }

    if (categoriesData.length === 0 && !error) {
        return <div className="page-content">Loading Add-ons...</div>;
    }

    return (
        <div className="page-content">
            <div className="add-ons-page ptb-120" style={{background:'#CBBBDD',paddingTop: '280px'}}>
                <div className="container card-row-addons">
                    {categoriesData.map((categoryObj, index) => (
                        <div key={index} className="category-section mb-5 ">
                            <div className="section-title addon-section">
                                <h2>{categoryObj.category_name}</h2> 
                            </div>
                            <div className="row ">
                                {categoryObj.addons.map((addon, i) => (
                                    <div className="col-lg-3 col-md-6 col-sm-4 mb-4" key={i}>
                                        <div className="card addon-card">
                                            <img
                                                src={`https://api.blingnbliss.in/${addon.image}`}
                                                alt={addon.addons_name}
                                                className="card-img-top"
                                            />
                                            <div className="card-body">
                                                <h5 className="card-title ">{addon.addons_name}</h5>
                                                <p className="card-text">Price: ₹{addon.price}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AddonsPage;